import EditProduct from "../components/EditProduct";

function EditProductPage() {
    return (
        <main>
            <EditProduct />
        </main>
    )
}

export default EditProductPage;